import { render, staticRenderFns } from "./DashboardDateWidget.vue?vue&type=template&id=06c4bf85"
import script from "./DashboardDateWidget.vue?vue&type=script&lang=js"
export * from "./DashboardDateWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports